import { render, staticRenderFns } from "./AiAgent.vue?vue&type=template&id=22135e36&scoped=true"
import script from "./AiAgent.vue?vue&type=script&lang=js"
export * from "./AiAgent.vue?vue&type=script&lang=js"
import style0 from "./AiAgent.vue?vue&type=style&index=0&id=22135e36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22135e36",
  null
  
)

export default component.exports